module.exports = __webpack_public_path__ + "static/triviaApi-b9e653e2a287fe0adbce424153823be2.png";